// Zentrale Geschäftsdaten für JSON-LD-Schemas (Single Source of Truth)
export const BUSINESS = {
  name: 'AK TechSolutions',
  url: 'https://aktechsolutions.de',
  email: 'requests@aktechsolutions.de',
  telephone: '+4915157877989',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Sägeweg 2',
    addressLocality: 'Neuenburg am Rhein',
    postalCode: '79395',
    addressCountry: 'DE',
  },
} as const;
